import { useMemo } from "react";

import useCanManageStackRoleBindings from "shared/Stack/access/useCanManageStackRoleBindings";
import { Stack } from "types/generated";

import { StackCreationWizardStep, StackFormFields, StackCreationWizardNavStep } from "./types";

export const useAvailableSteps = (formData: StackFormFields): StackCreationWizardNavStep[] => {
  const canManageStackRoleBindings = useCanManageStackRoleBindings();

  const shouldIncludeRolesStep = useMemo(
    () =>
      canManageStackRoleBindings({
        space: formData[StackCreationWizardStep.Details].space,
      } as Stack).result,
    [formData, canManageStackRoleBindings]
  );

  return useMemo(
    () => [
      {
        name: "Stack details",
        summaryName: "Details",
        step: StackCreationWizardStep.Details,
      },
      {
        name: "Connect to source code",
        summaryName: "Source code",
        step: StackCreationWizardStep.Vcs,
      },
      {
        name: "Choose vendor",
        summaryName: "Vendor",
        step: StackCreationWizardStep.Vendor,
      },
      {
        name: "Define behavior",
        isOptional: true,
        summaryName: "Behavior",
        step: StackCreationWizardStep.Behaviour,
      },
      {
        name: "Add hooks",
        isOptional: true,
        summaryName: "Hooks",
        step: StackCreationWizardStep.Hooks,
      },
      ...(shouldIncludeRolesStep
        ? ([
            {
              name: "Assign roles",
              isOptional: true,
              summaryName: "Assigned roles",
              step: StackCreationWizardStep.Roles,
            },
          ] as StackCreationWizardNavStep[])
        : []),
      {
        name: "Attach cloud",
        isOptional: true,
        summaryName: "Cloud integration",
        step: StackCreationWizardStep.Cloud,
      },
      {
        name: "Attach policies",
        isOptional: true,
        summaryName: "Attached policies",
        step: StackCreationWizardStep.Policies,
      },
      {
        name: "Attach context",
        isOptional: true,
        summaryName: "Attached contexts",
        step: StackCreationWizardStep.AttachContext,
      },
    ],
    [shouldIncludeRolesStep]
  );
};
